export enum ClientActions {
  GetClients = 'get clients from reservations',
  PutClients = 'put clients to store',
  SetFilter = 'set clients list filter',
  SetOrder = 'set clients list order',
  SetPage = 'set clients list page',
  SetPagination = 'set clients list pagination',
  OpenReservationInfoModal = 'open reservation info modal',
  SetInfoModalEvents = 'set info modal events',
  CloseInfoModal = 'close reservation info modal',
}
